export default __webpack_public_path__ + "static/media/12-32-23.1171d762.jpg";